import React from "react";

// A single component throw (e.g. a third-party library's synchronous error)
// should never blank the entire PWA — catch it and offer a reload instead.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled UI error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-primary px-4 text-center" data-testid="error-boundary-fallback">
          <p className="font-heading text-lg font-semibold text-white">Something went wrong</p>
          <p className="text-sm text-white/70">Please reload the page and try again.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-2 rounded-md bg-accent px-4 py-2 text-sm font-medium text-primary"
            data-testid="error-boundary-reload-button"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
